import { ref } from 'vue'

export type ConfirmOptions = {
  title?: string
  message?: string
  buttonTitle?: string
  danger?: boolean // defaults to true — controls red backdrop, button color and icon
}

type PendingConfirm = {
  options: ConfirmOptions
  resolve: (confirmed: boolean) => void
}

// Module-level so the state is shared across all component instances
const pending = ref<PendingConfirm | null>(null)

export function useConfirm() {
  const confirm = (options: ConfirmOptions = {}): Promise<boolean> => {
    return new Promise((resolve) => {
      pending.value = { options, resolve }
    })
  }

  const onConfirm = () => {
    pending.value?.resolve(true)
    pending.value = null
  }

  const onCancel = () => {
    pending.value?.resolve(false)
    pending.value = null
  }

  return { pending, confirm, onConfirm, onCancel }
}
